var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuidance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 98,
    viewBox: "0 0 70 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.0208 90.3524C68.0208 92.164 66.7359 93.7129 65.1518 93.8053L4.03512 97.3735C2.22017 97.4794 0.738281 95.9807 0.738281 94.0326V6.33019C0.738281 4.38165 2.22017 2.85665 4.03512 2.93029L65.1518 5.40787C66.7359 5.47196 68.0208 6.99815 68.0208 8.80976V90.3524Z",
    fill: "#4E5B36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8138 90.3524C69.8138 92.164 68.5289 93.7129 66.9447 93.8053L5.82809 97.3735C4.01314 97.4794 2.53125 95.9807 2.53125 94.0326V6.33019C2.53125 4.38165 4.01314 2.85665 5.82809 2.93029L66.9447 5.40787C68.5289 5.47196 69.8138 6.99815 69.8138 8.80976V90.3524Z",
    fill: "#60753C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6363 86.6475C67.6363 87.0089 67.3466 87.3174 66.9909 87.3357L5.78113 90.4665C5.37444 90.4872 5.04297 90.1899 5.04297 89.8029V6.38697C5.04297 6.00044 5.37444 5.69831 5.78113 5.71343L66.9909 8.01626C67.347 8.02979 67.6363 8.33471 67.6363 8.69576V86.6475Z",
    fill: "#506330"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5701 92.0789L31.1412 92.7628C30.4767 92.7994 29.9375 92.3385 29.9375 91.7334V91.688C29.9375 91.083 30.4767 90.5639 31.1412 90.5288L43.5701 89.8748C44.216 89.841 44.7389 90.296 44.7389 90.8915V90.9361C44.7389 91.5316 44.216 92.0431 43.5701 92.0785V92.0789Z",
    fill: "#506330"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0351 5.81974C38.0351 6.14178 37.7506 6.39176 37.3988 6.37823C37.047 6.3647 36.7617 6.09242 36.7617 5.76998C36.7617 5.44755 37.047 5.19756 37.3988 5.21149C37.7502 5.22543 38.0351 5.4977 38.0351 5.81934V5.81974Z",
    fill: "#FF9085"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2555 83.7912L8.25781 87.8487L8.55347 4.7373L63.2555 6.04456V83.7912Z",
    fill: "#60753C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8497 16.3925L11.9453 16.1338L11.9672 9.20898L36.8608 9.66995L36.8497 16.3925Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3756 33.934L18.3828 34.0196L18.4063 25.2852L26.3947 25.2864L26.3756 33.934Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.046 29.415L28.9375 29.5858L28.9463 25.2743L57.0476 25.25L57.046 29.415Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.334 51.3886L18.332 51.6501L18.3559 42.8966L26.3531 42.7227L26.334 51.3886Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0372 46.2222L28.8984 46.9857L28.9072 42.665L57.0388 42.0488L57.0372 46.2222Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2963 68.88L18.2852 69.3178L18.309 60.5456L26.3154 60.1953L26.2963 68.88Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0366 63.063L28.8672 64.422L28.8759 60.0918L57.0381 58.8809L57.0366 63.063Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1663 1.43421V79.1817L43.2078 80.803L10.1992 83.2384L10.4794 0.126953L30.8692 0.614188L65.1663 1.43421Z",
    fill: "#D4D9B4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M38.8223 11.7812L13.918 11.5228L13.9399 4.59766L38.8335 5.05862L38.8223 11.7812Z",
    fill: "#748A55"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M28.899 29.8998L20.9062 29.9854L20.9297 21.251L28.9181 21.2522L28.899 29.8998Z",
    fill: "#748A55"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.5737 25.3798L31.4648 25.5506L31.474 21.2391L59.5749 21.2148L59.5737 25.3798Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M28.8613 47.3554L20.8594 47.6169L20.8833 38.8634L28.8804 38.6895L28.8613 47.3554Z",
    fill: "#748A55"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.5645 42.187L31.4258 42.9505L31.4345 38.6299L59.5661 38.0137L59.5645 42.187Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M28.8236 64.8448L20.8125 65.2827L20.8364 56.5105L28.8427 56.1602L28.8236 64.8448Z",
    fill: "#748A55"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.5561 59.0307L31.3867 60.3893L31.3955 56.0596L59.5573 54.8486L59.5561 59.0307Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidance);
export default __webpack_public_path__ + "static/media/guidance.ba7710bd52f631376d25ad560e32b7cf.svg";
export { ForwardRef as ReactComponent };